import React from 'react'
import './services.css'
import { BiCheck } from 'react-icons/bi'

const Services = () => {
  return (
    <section id='services'>
      <h5>What Can I Do?</h5>
      <h2>Capabilities</h2>

      <div className="container services__container">

        {/* START OF WEB DEV */}
        <article className="service">
          <div className="service__head">
            <h3>Website Design &amp; Development</h3>
          </div>
          <ul className="service__list">
            <li>
              <BiCheck className='service__list-icon' />
              <p>Online App &amp; Tools, etc.</p>
            </li>
            <li>
              <BiCheck className='service__list-icon' />
              <p>Corporate/Business Website</p>
            </li>
            <li>
              <BiCheck className='service__list-icon' />
              <p>Ecommerce Website</p>
            </li>
            <li>
              <BiCheck className='service__list-icon' />
              <p>Portfolio Website</p>
            </li>
            <li>
              <BiCheck className='service__list-icon' />
              <p>Landing page</p>
            </li>
          </ul>
        </article>
        {/* END OF WEB DEV */}

        {/* START OF GRAPHIC DESIGN */}
        <article className="service">
          <div className="service__head">
            <h3>Graphic Design</h3>
          </div>
          <ul className="service__list">
            <li>
              <BiCheck className='service__list-icon' />
              <p>3D Modeling (Perspective View, Product Modeling)</p>
            </li>
            <li>
              <BiCheck className='service__list-icon' />
              <p>Branding Packages Design</p>
            </li>
            <li>
              <BiCheck className='service__list-icon' />
              <p>Logo, Brochure, Flyer, Banner</p>
            </li>
            <li>
              <BiCheck className='service__list-icon' />
              <p>Social Media Ad and Post Design</p>
            </li>
            <li>
              <BiCheck className='service__list-icon' />
              <p>Company Profile</p>
            </li>
            <li>
              <BiCheck className='service__list-icon' />
              <p>UI/UX Design</p>
            </li>
          </ul>
        </article>
        {/* END OF GRAPHIC DESIGN */}

        {/* START OF DIGITAL MARKETING */}
        <article className="service">
          <div className="service__head">
            <h3>Digital Marketing</h3>
          </div>
          <ul className="service__list">
            <li>
              <BiCheck className='service__list-icon' />
              <p>Search Engine Optimization (SEO)</p>
            </li>
            <li>
              <BiCheck className='service__list-icon' />
              <p>Content Generation and Optimization</p>
            </li>
            <li>
              <BiCheck className='service__list-icon' />
              <p>Online Advertising</p>
            </li>
            <li>
              <BiCheck className='service__list-icon' />
              <p>Social Media Marketing</p>
            </li>
            <li>
              <BiCheck className='service__list-icon' />
              <p>Website Strategy</p>
            </li>
            <li>
              <BiCheck className='service__list-icon' />
              <p>Email Outreach</p>
            </li>
          </ul>
        </article>
        {/* END OF DIGITAL MARKETING */}


      </div>
    </section>
  )
}

export default Services